import { render, staticRenderFns } from "./TreatFaceSection.vue?vue&type=template&id=0abe4efd&scoped=true"
import script from "./TreatFaceSection.vue?vue&type=script&lang=js"
export * from "./TreatFaceSection.vue?vue&type=script&lang=js"
import style0 from "./TreatFaceSection.vue?vue&type=style&index=0&id=0abe4efd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abe4efd",
  null
  
)

export default component.exports